<template>
    <LayoutSub>
        <SubSection class="pb-0" v-if="data">
            <ListNormalPage :data="data" />
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>
<script>
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import ListNormalPage from '../../common/ListNormalPage.vue';
import { getNewsList } from '@/api';

export default {
    components: {
        LayoutSub,
        SubSection,
        ListNormalPage,
        LoadingWrap,
    },
    data() {
        return {
            data: null,
        };
    },
    async mounted() {
        await this.getList();
    },
    watch: {
        async $route() {
            await this.getList();
        },
    },
    methods: {
        async getList() {
            try {
                const { paging: data } = await getNewsList(this.$route.query);
                this.data = data;
            } catch (err) {
                if (!this.data) this.data = null;
            }
        },
    },
};
</script>
